export default "__VITE_ASSET__BPR0eU$N__"